import React from "react";
import { useState, useRef } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { discountActivity } from "../../common/constants";

const Timer = ({ countDownDate, type, setIsDiscount, isToggle ,userToggle}) => {
  const [time, setTime] = useState({});
  const timerRef = useRef();
  const [isTimerOn, setIsTimerOn] = useState(true);

  const discountAmount = useSelector((store) => store?.userDiscount?.discount);
  const discountData = useSelector((store) => store?.userDiscount);

  
  function getReason() {
    if (discountData?.discount_type === "activity") {
      if (discountActivity?.ASK_DOUBT?.type === discountData?.discount_name) {
        return (
          "Don’t miss this special price you unlocked by " +
          discountActivity?.ASK_DOUBT?.message
        );
      } else if (
        discountActivity?.MSKILL_COMPLETED?.type === discountData?.discount_name
      ) {
        return (
          "Don’t miss this special price you unlocked by " +
          discountActivity?.MSKILL_COMPLETED?.message
        );
      } else if (
        discountActivity?.MSKILL_ENROLLED?.type === discountData?.discount_name
      ) {
        return (
          "Don’t miss this special price you unlocked by " +
          discountActivity?.MSKILL_ENROLLED?.message
        );
      } else if (
        discountActivity?.COMPLETED_TWO_LESSONS_IN_SKILL?.type ===
        discountData?.discount_name
      ) {
        return (
          "Don’t miss this special price you unlocked by " +
          discountActivity?.COMPLETED_TWO_LESSONS_IN_SKILL?.message
        );
      } else if (
        discountActivity?.COMPLETED_TWO_MSKILL?.type ===
        discountData?.discount_name
      ) {
        return (
          "Don’t miss this special price you unlocked by " +
          discountActivity?.COMPLETED_TWO_MSKILL?.message
        );
      } else if (
        discountActivity?.TRIAL_ENDED?.type ===
        discountData?.discount_name
      ) {
        return (
          "Don’t miss this special price you unlocked by " +
          discountActivity?.TRIAL_ENDED?.message
        );
      }
    } else {
      return discountData?.discount_name;
    }
  }
  //const countDownDate =  duration?.duration?.month>=0 ?  : new Date(new Date().toDateString() + ' 24:00:00').getTime();
  //const countDownDate = new Date(2022,7,29,11,4,0).getTime();

  useEffect(() => {
    timerRef.current = setInterval(function () {
      const now = Date.now();
      const timeleft = countDownDate - now;
      const hours = Math.floor(timeleft / (1000 * 60 * 60));
      const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
      if (hours < 0 && minutes < 0 && seconds < 0) {
        setIsTimerOn(false);
        setIsDiscount(false);
      } else {
        setIsTimerOn(true);
        setIsDiscount(true);
      }

      // Result is output to the specific element
      // document.getElementById('days').innerHTML = days + 'd ';
      setTime({ h: hours, m: minutes, s: seconds });

      // Display the message when countdown is over
      if (timeleft < 0) {
        clearInterval(timerRef.current);
        // setTime to 0
      }
    }, 1000);

    return () => {
      clearInterval(timerRef.current);
    };
  }, [countDownDate]);
  return isTimerOn && discountData !== null ? (
    <>
      <div
        className={`flex items-end  justify-center text-xl font-medium ${type === "coin" ? "mt-5" : "mt-10"
          }`}
      >
        Your&nbsp;{" "}
        <small className="text-2xl text-red-600">
          {type === "annual"
            ? isToggle
              ? Math.floor(discountAmount / 2)
              : discountAmount
            : Math.floor(discountAmount / 2)}
          %
        </small>
        &nbsp;Discount Expires In
      </div>
      <div className={`mt-4 mb-6 flex w-11/12 flex-col items-center justify-center rounded-lg border-2 border-dashed border-pricing_blue pt-7 pb-5 md:w-7/12 lg:w-5/12  ${!userToggle && 'bg-[#CBF2FF]'} `}>
        <div className="flex flex-row ">
          <div className="mr-5 ml-5 flex flex-col items-center justify-center md:mr-8 md:ml-8">
            <h1 className="text-5xl font-bold text-pricing_blue">{time?.h}</h1>
            <h1 className="text-2xl text-pricing_blue ">Hours</h1>
          </div>
          <div className="mr-5 ml-5 flex flex-col items-center justify-center md:mr-8 md:ml-8">
            <h1 className="text-5xl font-bold text-pricing_blue">{time?.m}</h1>
            <h1 className="text-2xl text-pricing_blue ">Mins</h1>
          </div>
          <div className="mr-5 ml-5 flex flex-col items-center justify-center md:mr-8 md:ml-8">
            <h1 className="text-5xl font-bold text-pricing_blue">{time?.s}</h1>
            <h1 className="text-2xl text-pricing_blue ">Sec.</h1>
          </div>
        </div>
        <div className="mt-5 text-center text-sm font-medium text-pricing_blue">
          {getReason()}
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default Timer;
